import React from 'react';
import ManageBm from './ManageBm';

const ManageBmContainer = () => {
  return <ManageBm />;
};

export default ManageBmContainer;
